import { render, staticRenderFns } from "./goodConstructor.vue?vue&type=template&id=549fad75&scoped=true&"
import script from "./goodConstructor.vue?vue&type=script&lang=js&"
export * from "./goodConstructor.vue?vue&type=script&lang=js&"
import style0 from "./goodConstructor.vue?vue&type=style&index=0&id=549fad75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fad75",
  null
  
)

export default component.exports